"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ModalFramePortal = _interopRequireDefault(require("./ModalFramePortal"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 100%;\n  width: 100%;\n  border: 0;\n  position: absolute;\n  z-index: 9999999;\n  top: ", "px;\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalFrameFrame = _styledComponents.default.iframe.withConfig({
  displayName: "ModalFrame__ModalFrameFrame",
  componentId: "x436zf-0"
})(_templateObject(), function (_ref) {
  var scrollTop = _ref.scrollTop;
  return scrollTop;
}, function (_ref2) {
  var frameReady = _ref2.frameReady;
  return frameReady ? null : 'none';
});

function verifyMessage(ref, event) {
  return ref.current.contentWindow === event.source;
}

function matchMessage(event, message) {
  return event.data === message;
}

function ModalFrame(_ref3) {
  var src = _ref3.src,
      frameReady = _ref3.frameReady,
      onFrameReady = _ref3.onFrameReady,
      onFrameClose = _ref3.onFrameClose;
  var scrollTop = (0, _react.useRef)(0);
  var modalRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var handlePostMessage = function handlePostMessage(event) {
      if (verifyMessage(modalRef, event)) {
        if (matchMessage(event, 'FRAME_READY')) {
          scrollTop.current = document.documentElement.scrollTop;
          onFrameReady();
        }

        if (matchMessage(event, 'CLOSE_FRAME')) {
          onFrameClose();
        }

        if (matchMessage(event, 'RELOAD_PARENT')) {
          window.location.reload(true);
        }
      }
    };

    window.addEventListener('message', handlePostMessage);
    return function () {
      window.removeEventListener('message', handlePostMessage);
    };
  }, [onFrameClose, onFrameReady]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ModalFramePortal.default, null, _react.default.createElement(ModalFrameFrame, {
    id: "ui-addon-upgrade-modal-frame",
    src: src,
    innerRef: modalRef,
    frameReady: frameReady,
    scrollTop: scrollTop.current
  })));
}

var _default = ModalFrame;
exports.default = _default;
module.exports = exports.default;